import React, { createContext, useState } from "react";

export const InfoWindowContext = createContext([]);

const initialState = {
    infoWindowPosition: null,
    infoWindowMarkerInfo: null,
};

export const InfoWindowContextProvider = props => {
    const [infoWindowState, setInfoWindowState] = useState(initialState);

    return (
        <InfoWindowContext.Provider value={[infoWindowState, setInfoWindowState]}>
            {props.children}
        </InfoWindowContext.Provider>
    );
};